export default __webpack_public_path__ + "static/media/fortune-bg.2c94edb8.jpg";